import moment from "moment";

const formatDate = (date : any) => {
    if (!date) return null;
    // Check if date is already in YYYY-MM-DD format
    if (moment(date, 'YYYY-MM-DD', true).isValid()) {
      return date;
    }
    // Parse date in DD/MM/YYYY format and convert to YYYY-MM-DD
    return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
  };

  export default formatDate